const DEV_STATIONS_URL = 'http://localhost:8080/stations';
const PROD_STATIONS_URL = 'https://keyfiyathava.ahooai.ir/stations';

export const STATIONS_URL = __DEV__ ? DEV_STATIONS_URL : PROD_STATIONS_URL;
